import { getLanguage, getNavPath } from "auth-provider";
import { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import { LabelType, PageHeader } from "screens/register/page-header";
import { LogoLogin, PageRegister } from "screens/register/page-register";
import loginLogo from "assets/loginLogo.png";
import walletCard from "assets/walletCard.png";
import defaultBanner from "assets/defaultBanner.png";
import defaultLogo from "assets/defaultLogo.png";
import rightArrowIcon from "assets/right_arrow_icon.png";
import Qrcode from "qrcode.react";
import {
  DisplayText,
  FullPageLoading,
  Rectangle,
  Row,
  ThemeText,
} from "components/lib";
import styled from "@emotion/styled";
import {
  getErrorMsg,
  showErrorMsg,
} from "utils/http";
import {
  checkAndSetRestaurantInfo,
  sendMessageToParent,
  setIsMemberCookie,
  StorageMobile,
} from "screens/register/util";
import { useAuth } from "context/auth-context";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { AccessTokenQueryKey } from "utils/oauth";
import {
  formatCountAndBack,
  getBrowserType,
  getLoyaltyMemberJoinStatus,
  isLoyaltyMemberExpired,
  slicePhoneNumber,
  useWindowSize,
} from "utils";
import { LoadingOutlined } from "@ant-design/icons";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import {
  RestaurantCardDatas,
  RestaurantWarnTips,
} from "screens/register/contant";
import { OrderList } from "./order-list";
import { useUrlQueryParam } from "utils/url";
import { getMaxNum, getNumber, useRechargeModel } from "./util";
import { DrawGift } from "./draw-gift";
import { DrawAnnualFeeRecharge } from "./draw-annual-fee";
import { DialogResult } from "./dialog-result";
import { RechargeType } from "types/joinAsMemberMode";
import React from "react";
import { RechargeDeal } from "types/loyalty";
import { useLoyaltyMemberService } from "hook/useLoyaltyMemberServiceHook";
import { RestaurantListInRestarantGroup } from "./restaurant-group";
import { BrandedAppDonwLoadLink } from "screens/brandedAppDownload";

const restaurantInfo = {
  name: { zh: "", en: "" },
};

const restaurantGroupTips = {
  stores: {
    zh: ['', '家餐厅通用'],
    en: ['Applicable to ', ' stores'],
  },
  expand: {
    zh: '查看',
    en: '',
  }
}

const loyaltyMemberStatus = {
  pedding: {
    zh: '待支付',
    en: 'Pending',
  },
  expired: {
    zh: '已过期',
    en: 'Expired',
  }
}

const LoyaltyMemeberStatusSpan = styled(ThemeText)`
font-style: normal;
font-weight: 500;
color: #E00051;
display: inline;
padding-left:5px;

`;

const RechardActionButtons = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
export const RenderLoyaltyMemberStatus = (props: { loyaltyMember: LoyaltyMember, lang: LabelType }) => {
  let { loyaltyMember, lang } = props;
  let { memberIsActive, } = loyaltyMember || {};

  const expired = useMemo(() => {
    return isLoyaltyMemberExpired(loyaltyMember);
  }, [loyaltyMember]);


  if (!memberIsActive) {
    return <React.Fragment><LoyaltyMemeberStatusSpan>{loyaltyMemberStatus.pedding[lang]}</LoyaltyMemeberStatusSpan></React.Fragment>;
  }
  if (expired) {
    return <React.Fragment><LoyaltyMemeberStatusSpan>{loyaltyMemberStatus.expired[lang]}</LoyaltyMemeberStatusSpan></React.Fragment>;
  }

  return null;
}

const RechargeButtons = (props: { loyaltyMember: LoyaltyMember, maxAmount: number, handleClickCharge: (forAnnualRecharge: boolean) => void; lang: LabelType }) => {
  let { loyaltyMember, maxAmount, lang, handleClickCharge } = props;
  const { disountData } = useAuth();
  let { rechargeJoinModeActived, annualFeeAmount, annualJoinModeActived, annualJoinModeExpiredActived } = useMemo(() => {
    return getLoyaltyMemberJoinStatus(loyaltyMember, disountData);
  }, [loyaltyMember, disountData]);


  if (annualJoinModeExpiredActived) {
    return <React.Fragment>
      <BrandedAppDonwLoadLink />
      <RechardActionButtons style={{ width: '34.3rem', margin: '0 auto 2.4rem auto' }} >
        <CardBtn
          width={34.3}
          height={4.4}
          background={"#FADEB2"}
          style={{ border: "none", width: '100%', marginTop: 0 }}
          onClick={() => { handleClickCharge(false); }}
        >
          <ThemeText
            fontSize={1.6}
            fontWieght={600}
            style={styleObj.cardText}
            fontColor={"#1D1B2E"}
          >
            {`${RestaurantCardDatas.rechargeZero[lang]}`}
          </ThemeText>
        </CardBtn>
        <CardBtn
          width={34.3}
          height={4.4}
          background={"#FADEB2"}
          style={{ border: "none", width: '100%', marginLeft: '13px', marginTop: 0 }}
          onClick={() => handleClickCharge(true)}
        >
          <ThemeText
            fontSize={1.6}
            fontWieght={600}
            style={styleObj.cardText}
            fontColor={"#1D1B2E"}
          >
            {`${RestaurantCardDatas.annualExpiredJoin[lang][0]}`}
            {/* <span style={{ color: '#E00051' }}>${annualFeeAmount}</span> */}
            {`${RestaurantCardDatas.annualExpiredJoin[lang][1]}`}
          </ThemeText>
        </CardBtn>
      </RechardActionButtons>
    </React.Fragment>
  }

  return <React.Fragment>
    {/* branded App donwlond link */}
    <BrandedAppDonwLoadLink />
    {
      (maxAmount > -1 || annualJoinModeActived) && (
        <CardBtn
          width={34.3}
          height={4.4}
          background={"#FADEB2"}
          style={{ border: "none", marginTop: 0, marginBottom: "2.4rem" }}
          onClick={() => handleClickCharge(annualJoinModeActived)}
        >
          <ThemeText
            fontSize={rechargeJoinModeActived ? 1.6 : 1.6}
            fontWieght={600}
            fontColor={"#1D1B2E"}
            style={{ whiteSpace: 'nowrap' }}
          >
            {
              rechargeJoinModeActived && `${RestaurantCardDatas.rechargeJoin[lang]}`
            }
            {
              annualJoinModeActived && <React.Fragment>
                {
                  `${RestaurantCardDatas.annualJoin[lang][0]}`
                }
                <span style={{ color: '#E00051' }}>${annualFeeAmount}</span>
                {
                  `${RestaurantCardDatas.annualJoin[lang][1]}`
                }
              </React.Fragment>
            }
            {
              !rechargeJoinModeActived && !annualJoinModeActived && <React.Fragment>
                {
                  maxAmount === 0 ? (
                    `${RestaurantCardDatas.rechargeZero[lang]}`
                  ) : (
                    <>
                      {RestaurantCardDatas.recharge[lang]}
                      <span style={styleObj.rechargeTxt}>
                        {maxAmount}
                        {lang === "zh" ? "%" : "% Bonus!"}
                      </span>
                    </>
                  )}
              </React.Fragment>
            }

          </ThemeText>
        </CardBtn>
      )}
  </React.Fragment>;
}

// qr_code
const styleObj = {
  left: { marginRight: "1.6rem" },
  right: { marginLeft: "-1.6rem", flexShrink: 0 },
  cardText: { marginLeft: "0.7rem" },
  tipBottomText: {
    margin: "1.2rem auto 0 auto",
    width: "34.3rem",
    textAlign: "center" as const,
  },
  btnImg: { width: "3.2rem", objectFit: "cover" as const },
  model: {
    width: "100%",
    height: "4.4rem",
    textAlign: "center" as const,
    position: "absolute" as const,
  },
  logoImg: {
    width: "3.2rem",
    height: "3.2rem",
    borderRadius: "0.4rem",
    objectFit: "cover" as const,
  },
  bannerImg: { width: "100%", height: "13rem", objectFit: "cover" as const },
  rechargeTxt: { color: "#E00051" },
};

type LoadState = {
  isDownload: boolean;
  isLoading: boolean;
  showModal: boolean;
  isClock: boolean;
};

type RestaurantPic = {
  restaurantLogo: string;
  restaurantBanner: string;
};

export type Recharge = {
  recharge?: string;
  back?: string;
  reChargeId?: any;
  name?: any;
  foreign_name?: any;
};
export type LoyaltyMember = {
  memberId: string;
  userName: string;
  email: string;
  restaurantId: string;
  phoneNumber: string;
  memberIsActive: boolean,
  expirationDate: string | null;
  availableCredit: string;
  birthday: string;
  cashBack: string;
  inWallet: boolean;
}

export const packLists = (data: RechargeDeal[]) => {
  return data
    .filter((item: RechargeDeal) => {
      const cash = parseFloat(item?.cash_amount || '0');
      return !isNaN(cash) && cash > 0;
    })
    .map((item) => {
      return {
        recharge: getNumber(
          item?.cash_amount as string,
          2
        ),
        back: getNumber(
          item?.bonus_amount as string,
          2
        ),
        reChargeId: item.id || Math.floor(Math.random() * 1000) + "",
        name: item.name,
        foreign_name: item.foreign_name,
      };
    });
};

export const RestaurantCard = (props: { setLang: any }) => {
  const trackCommonData = useTrackCommonData();

  const [lang, setLang] = useState(getLanguage() as LabelType);
  const { startDownloadWalletCard } = useLoyaltyMemberService();

  const [loadState, dispathLoadState] = useReducer(
    (state: LoadState, action: Partial<LoadState>) => ({ ...state, ...action }),
    {
      isDownload: false,
      isClock: false,
      isLoading: true,
      showModal: true,
    }
  );

  const [clickCount, setClickCount] = useState(0);
  const [restaurantUuid, setUuid] = useState("");
  // 刷新餐厅积
  const [qrLink, setQrLink] = useState("");
  const [cashBack, setCashBack] = useState("");
  const [availableBalance, setAvailableBalance] = useState("");
  const [username, setUsername] = useState("");
  const [memberIsActive, setMemberIsActive] = useState(false);
  const [expiredDate, setExpiredDate] = useState("");
  const [usablePoints, setUsablePoints] = useState(0);
  const [bindedloyaltyMember, setBindedloyaltyMember] = useState<LoyaltyMember | null>(null);
  const [inWallet, setIsInWallet] = useState(false);
  const [cardDownloaded, setCardDownload] = useState(false);
  const [isRefetch, setIsRefetch] = useState(false);
  const [interval, setIntervalval] = useState(0);

  const [rechargeList, setRecharge] = useState([] as Recharge[]);
  const [maxAmount, setMaxamount] = useState(-1);
  const [refresh, setRefresh] = useState(0);
  // 支付状态
  const [payStatus, setPayStatus] = useState("");
  const [rechargeType, setRechargeType] = useState(RechargeType.normal_gift_card_recharge);

  const { openRecharge } = useRechargeModel();

  const { restaurant: restaurantData, restaurantCode, disountData, restaurantLoyaltySetting, restaurantGroupInfo } = useAuth();
  const { fetchLoyaltyMember, toggleLang } = useLoyaltyMemberService();
  const [openRestaurantListOnGroup, setOpenRestaurantListOnGroup] = useState(false);

  const navigate = useNavigate();
  const { width: currentWidth } = useWindowSize();

  let isSafari = getBrowserType().browserName === "Safari";
  restaurantInfo.name.en = restaurantData.data.attributes.name;
  restaurantInfo.name.zh = restaurantData.data.attributes.foreign_name;

  const [logoPic, dispathLogoPic] = useReducer(
    (state: RestaurantPic, action: Partial<RestaurantPic>) => ({
      ...state,
      ...action,
    }),
    {
      restaurantLogo: restaurantData?.data?.attributes?.wallet_logo_url || "",
      restaurantBanner: restaurantData?.data?.attributes?.image_url || "",
    }
  );

  useEffect(() => {

  })

  const phoneNumber = StorageMobile("get") || "";

  const backNum = formatCountAndBack(disountData?.cash_back_ratio || '');

  // 大屏状态下，二维码放大
  const qrCodeWidth = currentWidth > 600 ? 145 : currentWidth < 340 ? 72.5 : 90;

  const updateRechargeResult = useCallback((payStatus: string, rechargeType: RechargeType) => {
    setPayStatus(payStatus);
    setRechargeType(rechargeType);
  }, []);

  const changeLang = (val: LabelType) => {
    setLang(val);
    props?.setLang?.(val);
  };

  const clickOrderIcon = () => {
    trackMixPanel(MIX_PANEL_EVENT.ORDER_LIST_CLICK, trackCommonData);
    showOrderHistory();
  };

  const showOrderHistory = useCallback(() => {
    setClickCount((val) => val + 1);
  }, []);

  const [{ dialogFrom }, setDialogClose] = useUrlQueryParam(["dialogFrom"]);
  const backToLogin = useCallback(() => {
    const navPath = getNavPath("member");
    navigate(navPath, { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (restaurantLoyaltySetting) {
      let prepaidDealList = restaurantLoyaltySetting.prepaidDealList;
      if (!prepaidDealList || prepaidDealList.length === 0) {
        setRecharge([]);
        setMaxamount(-1);
      } else {
        const lists = packLists(prepaidDealList);
        setRecharge(lists);
        setMaxamount(getMaxNum(lists));
      }

    }
  }, [restaurantLoyaltySetting]);

  // 获取餐厅信息
  const getRestQrcodeCashback = useCallback(() => {
    dispathLoadState({ isLoading: true });
    fetchLoyaltyMember(lang)
      .then((data) => {
        dispathLoadState({ isLoading: false, showModal: false });
        if (!data) {
          return;
        }
        const { attributes, id: memberId } = data?.data;

        if (!attributes || typeof attributes !== "object") {
          message.error("No restaurant info!");
          return;
        }

        if (attributes.qr_code) {
          setQrLink(attributes.qr_code);
        } else {
          message.error("qr_code lost !");
        }
        let credit = attributes?.credit || "0.0";
        let available_credit = attributes?.available_credit || "0.0";
        setCashBack(credit);
        setAvailableBalance(available_credit);
        setUsername(attributes?.name || "user");
        setMemberIsActive(attributes?.member_is_active || false);
        setExpiredDate(attributes?.expiration_date || "");
        setUsablePoints(attributes?.usable_points || 0);
        setBindedloyaltyMember(!attributes ? null : {
          memberId: memberId,
          userName: attributes.name,
          email: attributes.email,
          restaurantId: attributes.restaurant_id,
          phoneNumber: attributes.phone_number,
          memberIsActive: attributes.member_is_active,
          expirationDate: attributes.expiration_date || null,
          availableCredit: attributes.available_credit,
          birthday: attributes.birthday,
          cashBack: attributes.cash_back,
          inWallet: attributes.in_wallet,
        });
        setUuid(data?.data?.id || "");
        // 不在wallet，主动弹出下载
        let inWalletFlag = attributes?.in_wallet || false;
        setIsInWallet(inWalletFlag);
        if (dialogFrom === "orderList" && (inWalletFlag || !isSafari)) {
          showOrderHistory();
        }
        if (inWalletFlag && isSafari) {
          trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_WALLET_ADDED, {
            mNo: slicePhoneNumber(phoneNumber),
            ...trackCommonData,
          });
        }
        // 注册流程走通后，将手机号和餐厅code存缓存；以后扫码时，直接登录
        checkAndSetRestaurantInfo("set", `${phoneNumber}`, restaurantCode);
        trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_SHOW_SUCCESS, trackCommonData);
        setIsMemberCookie("isMember", restaurantCode || "");
      })
      .catch((e) => {
        dispathLoadState({ isLoading: false, showModal: false });
        checkAndSetRestaurantInfo("remove", `${phoneNumber}`, restaurantCode);
        backToLogin();
        if (e?.errors && Array.isArray(e.errors) && e.errors.length) {
          const [{ code = "" }] = e.errors;
          if (code === "LOYALTY_RESTAURANT_MEMBER_000") {
            message.info(RestaurantWarnTips.error[lang]);
          } else {
            showErrorMsg(e);
          }
        } else {
          showErrorMsg(e);
        }
        const msg = getErrorMsg(e);
        trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_SHOW_ERROR, {
          restaurant_id: restaurantData.data.id,
          errorApi: "api/{lang}/v1/restaurant_members/fetch",
          errorMsg: msg,
          mNo: slicePhoneNumber(phoneNumber),
          ...trackCommonData,
        });
      });
  }, [
    backToLogin,
    dialogFrom,
    isSafari,
    lang,
    phoneNumber,
    restaurantCode,
    restaurantData,
    showOrderHistory,
    trackCommonData,
    fetchLoyaltyMember,
  ]);

  const handleClickCard = () => {
    if (loadState.isDownload || loadState.isClock) return;
    trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_CLICK_DOWNLOAD, trackCommonData);
    setCardDownload(false);
    downloadCard();
  };

  const openRestaurantsGroup = useCallback(() => {
    if (!restaurantGroupInfo) {
      return;
    }

    setOpenRestaurantListOnGroup(true);

  }, [restaurantGroupInfo]);

  const onRestaurantListOpenChanged = useCallback((open: boolean) => {
    setOpenRestaurantListOnGroup(open);
  }, []);

  // todo: 打开充值draw
  const handleClickCharge = (forAnnualRecharge: boolean = false) => {
    setRefresh(refresh + 1);
    openRecharge("open", forAnnualRecharge);
    trackMixPanel(MIX_PANEL_EVENT.PREPAY_CLICK, trackCommonData);
  };


  const setClock = () => {
    dispathLoadState({ isClock: true });
    setTimeout(() => {
      dispathLoadState({ isClock: false });
    }, 5000);
  };

  const refetchResInfo = useCallback(() => {
    setIsRefetch(true);
    fetchLoyaltyMember(lang).then((data) => {
      setIsRefetch(false);
      if (!data) {
        return;
      }
      const { attributes, id: memberId } = data?.data;
      const inWalletFlag = attributes?.in_wallet || false;
      let credit = attributes?.credit || "0.0";
      let available_credit = attributes?.available_credit || "0.0";
      setCashBack(credit);
      setAvailableBalance(available_credit);
      setBindedloyaltyMember(!attributes ? null : {
        memberId: memberId,
        userName: attributes.name,
        email: attributes.email,
        restaurantId: attributes.restaurant_id,
        phoneNumber: attributes.phone_number,
        memberIsActive: attributes.member_is_active,
        expirationDate: attributes.expiration_date || null,
        availableCredit: attributes.available_credit,
        birthday: attributes.birthday,
        cashBack: attributes.cash_back,
        inWallet: attributes.in_wallet,
      });
      // has been added to wallet
      if (inWalletFlag) {
        setIsInWallet(inWalletFlag);
        trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_WALLET_ADDED, {
          mNo: slicePhoneNumber(phoneNumber),
          ...trackCommonData,
        });
      }
      setCashBack(attributes?.credit || "0.0");
    })
      .catch(() => {
        setIsRefetch(false);
      });
  }, [phoneNumber, trackCommonData, lang, fetchLoyaltyMember]);

  useEffect(() => {
    if (inWallet) {
      interval && clearInterval(interval);
      return;
    }
    // 在处理中
    if (!cardDownloaded || interval || isRefetch) {
      return;
    }
    // 刷新
    const tmpInterval = window.setInterval(() => {
      refetchResInfo();
    }, process.env.REACT_APP_REFRESH_RES_INFO ? Number.parseInt(process.env.REACT_APP_REFRESH_RES_INFO) : 3 * 1000);
    setIntervalval(tmpInterval);

    return () => clearInterval(interval);
  }, [cardDownloaded, inWallet, refetchResInfo, isRefetch, interval]);

  const downloadCard = () => {
    // 避免语言问题，下载卡片之前，先存语言
    const phone_number = StorageMobile("get");
    const restaurant_id = restaurantData?.data?.id;
    if (!phone_number || !restaurant_id) {
      backToLogin();
      return;
    }
    if (loadState.isDownload || loadState.isClock) return;
    dispathLoadState({ isDownload: true });
    setClock();
    toggleLang(lang, phone_number)
      .then(() => {
        startDownLoad();
      })
      .catch((e) => {
        startDownLoad();
        const msg = getErrorMsg(e);
        trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_SWITCH_LANGUAGE_FAILED, {
          errorApi: "api/{lang}/v1/restaurant_members/toggle_lang",
          restaurant_id,
          errorMsg: msg,
          mNo: slicePhoneNumber(phone_number),
          ...trackCommonData,
        });
      });
  };

  // 添加到applewallet
  const startDownLoad = () => {
    startDownloadWalletCard(lang, phoneNumber)
      .then((data) => {
        if (!data) {
          return;
        }
        dispathLoadState({ isDownload: false });
        if (!data) {
          return;
        }
        setCardDownload(true);
        trackMixPanel(
          MIX_PANEL_EVENT.RESTAURANT_DOWNLOAD_SUCCESS,
          trackCommonData
        );
        sendMessageToParent(
          {
            type: "mixpanel",
            data: {
              eventName: MIX_PANEL_EVENT.RESTAURANT_DOWNLOAD_SUCCESS,
              eventProps: { mNo: slicePhoneNumber(phoneNumber) },
            },
          },
          trackCommonData.source
        );
        const url = window.URL.createObjectURL(
          new Blob([data], { type: "application/vnd.apple.pkpass" })
        );
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "pass.pkpass");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((e) => {
        setCardDownload(true);
        dispathLoadState({ isDownload: false });
        const msg = getErrorMsg(e);
        trackMixPanel(MIX_PANEL_EVENT.RESTAURANT_DOWNLOAD_FAILED, {
          errorApi: `api/{lang}/v1/restaurant_member_cards`,
          errorMsg: msg,
          mNo: slicePhoneNumber(phoneNumber),
          restaurant_id: restaurantData.data.id,
          ...trackCommonData,
        });
        // 卡片下载失败，展示二维码
        setIsInWallet(true);
      });
  };

  const checkAuth = useCallback(() => {
    const accessTokenData = localStorage.getItem(AccessTokenQueryKey);
    if (phoneNumber && accessTokenData) {
      return true;
    }
    backToLogin();
  }, [phoneNumber, backToLogin]);

  useEffect(() => {
    if (checkAuth()) {
      getRestQrcodeCashback();
    }
  }, [checkAuth, getRestQrcodeCashback]);

  const afterLoad = () => {
    if (!inWallet && isSafari) {
      downloadCard();
    }
  };

  const handleError = (picType: "logo" | "banner") => {
    dispathLogoPic(
      picType === "logo"
        ? { restaurantLogo: defaultLogo }
        : { restaurantBanner: defaultBanner }
    );
  };

  const handleResetCount = () => {
    setClickCount(0);
    // 弹框时手动打开，手动刷新数据；自动打开时，关闭弹框 getRestQrcodeCashback会自动触发
    if (!dialogFrom) {
      getRestQrcodeCashback();
    } else {
      setDialogClose({ dialogFrom: "" });
    }
  };

  const RechargeComponent = () => {
    return <>
      {/* 充值弹框 */}
      {!!qrLink && (
        <DrawGift
          setPayStatus={updateRechargeResult}
          changeLang={changeLang}
          maxAmount={maxAmount}
          rechargeList={rechargeList}
          restaurantInfo={{ phoneNumber, memeberId: restaurantUuid, username }}
          refresh={refresh}
          loyaltyMember={bindedloyaltyMember as LoyaltyMember}
        />
      )}
      {/*年费充值*/}
      {
        !!qrLink && (
          <DrawAnnualFeeRecharge
            setPayStatus={updateRechargeResult}
            changeLang={changeLang}
            maxAmount={maxAmount}
            rechargeList={rechargeList}
            restaurantInfo={{ phoneNumber, memeberId: restaurantUuid, username }}
            refresh={refresh}
            loyaltyMember={bindedloyaltyMember as LoyaltyMember} />
        )
      }

      {/* 充值成功失败弹框 */}
      <DialogResult
        status={payStatus}
        rechargeType={rechargeType}
        successCallback={() => refetchResInfo()}
        changeStatus={(val: string) => setPayStatus(val)}
      />
    </>;
  }


  if (loadState.isLoading && loadState.showModal) {
    return <FullPageLoading></FullPageLoading>;
  }

  // 不在wallet、登录成功的safari、直接下载
  if (!inWallet && isSafari && process.env.REACT_APP_LOCAL_DEBUG !== '1') {
    return (
      <>
        <PageRegister
          setLang={setLang}
          fromRestaurant={true}
          username={username}
          loyaltyMember={bindedloyaltyMember}
          afterLoad={afterLoad}
        >
          <>
            <CardBtn
              width={34.3}
              height={4.4}
              background={"none"}
              style={{ margin: "auto auto 2.4rem auto" }}
              onClick={handleClickCard}
            >
              {(loadState.isDownload || loadState.isClock) && (
                <div style={styleObj.model}>
                  <LoadingIcon />
                </div>
              )}
              <img src={walletCard} style={styleObj.btnImg} alt="btn" />
              <ThemeText
                fontSize={lang === "zh" ? 1.8 : 1.4}
                fontWieght={600}
                style={styleObj.cardText}
              >
                {RestaurantCardDatas.btnText[lang]}
              </ThemeText>
            </CardBtn>
            <RechargeButtons loyaltyMember={bindedloyaltyMember as LoyaltyMember} lang={lang} maxAmount={maxAmount} handleClickCharge={handleClickCharge} />

          </>
        </PageRegister>
        {
          RechargeComponent()
        }
      </>
    );
  }


  return (
    <>
      <PageHeader
        changeLang={changeLang}
        isResaurant={true}
        showOrderHistory={clickOrderIcon}
      >
        <LogoLogin
          aliItem={"center"}
          justCon={"flex-start"}
          style={{ width: "25rem", height: "3.6rem", padding: 0, margin: 0 }}
        >
          <img src={loginLogo} alt="img" style={{ width: "2rem" }} />
          <LoginName fontColor={"#FADEB2"}>
            {username}
            {bindedloyaltyMember && <RenderLoyaltyMemberStatus loyaltyMember={bindedloyaltyMember as LoyaltyMember} lang={lang} />}
          </LoginName>
        </LogoLogin>
      </PageHeader>
      {/* <ThemeText>餐厅内容，餐厅内容</ThemeText> */}

      <DisplayText dir={"column"} style={{ margin: "auto" }}>
        <Container style={{ height: 'auto' }}>
          <HeaderWrapper between={true} marginBottom={1}>
            <DisplayText justCon={"flex-start"} style={{ marginRight: "auto" }}>
              <img
                src={logoPic.restaurantLogo}
                style={styleObj.logoImg}
                alt="logo"
                onError={() => handleError("logo")}
              />

              {
                restaurantGroupInfo && <div onClick={openRestaurantsGroup}>
                  <RestaurantName>{restaurantInfo.name[lang]}</RestaurantName>
                  <RestaurantGroupIndicator>
                    {`${restaurantGroupTips.stores[lang][0]}${restaurantGroupInfo.includRestaurantList.length}${restaurantGroupTips.stores[lang][1]}`} <span style={{ paddingLeft: '5px' }}>{`${restaurantGroupTips.expand[lang]}`}</span>
                  </RestaurantGroupIndicator>
                </div>
              }
              {
                !restaurantGroupInfo && <RestaurantName>{restaurantInfo.name[lang]}</RestaurantName>
              }
            </DisplayText>
            <BackTitle
              justCon={"flex-end"}
              dir={"column"}
              aliItem={"flex-end"}
              lang={lang}
            >
              <ThemeText fontSize={1.2} fontColor={"#FADEB2"}>
                {lang === "zh" && <span>{availableBalance !== cashBack ? `余额($${availableBalance}可用)` : `余额`}</span>}
                {lang === "en" && <span>{availableBalance !== cashBack ? `Balance($${availableBalance} available)` : `Balance`}</span>}
              </ThemeText>
              <ThemeText fontColor={"#FADEB2"} fontSize={2} fontWieght={600}>
                ${cashBack || "0"}
              </ThemeText>
            </BackTitle>
          </HeaderWrapper>
          {/* 餐厅图片 */}
          <img
            src={logoPic.restaurantBanner}
            onError={() => handleError("banner")}
            style={styleObj.bannerImg}
            alt="banner"
          />

          {/* 姓名和返现等 */}
          {lang === "zh" ? (
            <InfoConainerEn justCon={"space-between"} aliItem={"flex-start"} style={{ height: 'auto', marginBottom: '1.5rem' }}>
              <div style={styleObj.left}>
                {
                  memberIsActive ? <React.Fragment>
                    {
                      expiredDate ? <React.Fragment>
                        <LineOne>{username}</LineOne>
                        <LineTwo>{`有效期至${expiredDate}`}</LineTwo>
                      </React.Fragment> : <React.Fragment>
                        <LineOne>姓名</LineOne>
                        <LineTwo>{username}</LineTwo>
                      </React.Fragment>
                    }

                  </React.Fragment>
                    : <React.Fragment>
                      <LineOne>姓名</LineOne>
                      <LineTwo>{username}</LineTwo>
                    </React.Fragment>
                }
              </div>

              <div style={styleObj.right}>
                {/* <LineOne>结账请出示给服务员使用</LineOne>
                {!!backNum && (
                  <LineTwo style={{ textAlign: "right" }}>
                    每单享{backNum}%返现
                  </LineTwo>
                )} */}

                <LineOne>积分</LineOne>
                <LineTwo style={{ textAlign: "right" }}>
                  {usablePoints}pt
                </LineTwo>

              </div>
            </InfoConainerEn>
          ) : (
            <InfoConainerEn justCon={"space-between"} aliItem={"flex-start"} style={{ height: 'auto', marginBottom: '1.5rem' }}>
              <div style={styleObj.left}>
                {
                  memberIsActive ? <React.Fragment>
                    {
                      expiredDate ? <React.Fragment>
                        <LineOne>{username}</LineOne>
                        <LineTwo>{`Expired at ${expiredDate}`}</LineTwo>
                      </React.Fragment> : <React.Fragment>
                        <LineOne>Name</LineOne>
                        <LineTwo>{username}</LineTwo>
                      </React.Fragment>
                    }

                  </React.Fragment> : <React.Fragment>
                    <LineOne>Name</LineOne>
                    <LineTwo>{username}</LineTwo>
                  </React.Fragment>
                }

              </div>

              <div style={styleObj.right}>
                <LineOne style={{ wordSpacing: "-1px" }}>
                  Points
                </LineOne>
                <LineTwo style={{ textAlign: "right" }}>
                  {usablePoints}pt
                </LineTwo>

                {/* <LineOne style={{ wordSpacing: "-1px" }}>
                  {!!backNum
                    ? "Show to waiter to get"
                    : "Show to waiter at checkout"}
                </LineOne>
                {!!backNum && (
                  <LineTwo style={{ textAlign: "right" }}>
                    {backNum}% Cashback
                  </LineTwo>
                )} */}
              </div>
            </InfoConainerEn>
          )}
          <RectangelBox style={{ marginBottom: '1rem', position: 'static', }}>
            <Rectangle
              width={10.2}
              style={{
                padding: "0.6rem",
                margin: "0 auto",
                borderRadius: "0.8rem",
              }}
            >
              <Qrcode value={qrLink} size={qrCodeWidth} />

            </Rectangle>
            {/* <span style={{ display: 'flex', justifyContent: 'center', color: '#ffffff' }}>XXX</span> */}
            <LineTwo style={{ display: 'flex', justifyContent: 'center', lineHeight: 'normal', padding: '0.7rem 0' }}>
              {
                lang === "zh" ? <>
                  {!!backNum ? `结账出示` : `结账出示给服务员使用`}
                  {
                    !!backNum && `每单享${backNum}%返现`
                  }

                </> : <>
                  {!!backNum ? `Show to waiter to get ` : `Show to waiter at checkout `}
                  {
                    !!backNum && `${backNum}% Cashback`
                  }

                </>
              }

              {/* <LineOne style={{ wordSpacing: "-1px" }}>
                  {!!backNum
                    ? "Show to waiter to get"
                    : "Show to waiter at checkout"}
                </LineOne>
                {!!backNum && (
                  <LineTwo style={{ textAlign: "right" }}>
                    {backNum}% Cashback
                  </LineTwo>
                )} */}
            </LineTwo>
          </RectangelBox>
        </Container>

        {/* 添加卡片按钮 */}
        {isSafari && !inWallet && (
          <>
            <CardBtn
              width={34.3}
              height={4.4}
              background={"#050707"}
              onClick={handleClickCard}
            >
              {(loadState.isDownload || loadState.isClock) && (
                <div style={styleObj.model}>
                  <LoadingIcon />
                </div>
              )}
              <img src={walletCard} style={styleObj.btnImg} alt="btn" />
              <ThemeText
                fontSize={lang === "zh" ? 1.8 : 1.4}
                fontWieght={600}
                style={styleObj.cardText}
              >
                {RestaurantCardDatas.btnText[lang]}
              </ThemeText>
            </CardBtn>
            <ThemeText
              fontSize={1.4}
              fontColor={"#fff"}
              style={styleObj.tipBottomText}
            >
              {RestaurantCardDatas.btnBottomText[lang]}
            </ThemeText>
          </>
        )}
        <div style={{ marginTop: '2.4rem', width: '100%' }}>
          <RechargeButtons loyaltyMember={bindedloyaltyMember as LoyaltyMember} lang={lang} maxAmount={maxAmount} handleClickCharge={handleClickCharge} />
        </div>

        {restaurantUuid && (
          <OrderList
            lang={lang}
            clickCount={clickCount}
            resetCardCount={handleResetCount}
            restaurantNames={restaurantInfo.name}
            uuid={restaurantUuid}
          ></OrderList>
        )}

        {openRestaurantListOnGroup && <RestaurantListInRestarantGroup lang={lang} onOpenChanged={onRestaurantListOpenChanged} />}

      </DisplayText>

      {
        RechargeComponent()
      }
    </>
  );
};

const Container = styled.div`
  background: #1d1b2e;
  border: 1px solid #fadeb2;
  box-sizing: border-box;
  border-radius: 10px;
  width: 34.3rem;
  height: 39.2rem;
  margin: 0 auto;
  position: relative;
`;

const HeaderWrapper = styled(Row)`
  padding: 1rem 1.6rem 2rem 1.6rem;
  margin-bottom: 0;
`;

const RestaurantName = styled(ThemeText)`
  font-size: 1.4rem;
  margin-left: 0.7rem;
  padding-right: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 600;
  color: #fadeb2;
`;

const RestaurantGroupIndicator = styled(ThemeText)`
  font-size: 1.4rem;
  margin-left: 0.7rem;
  padding-right: 1.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  color: #fadeb2;
  display:flex;
  align-items: center;

  &:after {
    content: "";
    display:block;
    width:14px;
    height:14px;
    background-image:url(${rightArrowIcon});
    background-size:contain;
    background-repeat:no-repeat;
    background-position:center;
  }
`;


const BackTitle = styled(DisplayText) <{
  lang: LabelType;
}>`
  margin-left: -1.6rem;
  flex-shrink: 0;
`;

const CardBtn = styled(Rectangle)`
  border: 1px solid #a6a6a6;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 2rem auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const InfoConainerEn = styled(DisplayText)`
  font-family: PingFang SC;
  color: #fadeb2;
  padding: 0.4rem 1.6rem 0 1.6rem;
  height: 8.2rem;
`;

const LineOne = styled.div`
  font-size: 1.2rem;
  line-height: 1.7rem;
`;

const LineTwo = styled(ThemeText)`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 500;
  color: #fadeb2;
`;

const RectangelBox = styled.div`
  height: 12.6rem;
  width: 100%;
  position: absolute;
  bottom: 0;
`;

const LoginName = styled(ThemeText)`
  line-height: 1;
  margin-left: 0.6rem;
  font-family: PingFang SC;
  font-weight: 500;
`;

const LoadingIcon = styled(LoadingOutlined)`
  width: 30px;
  color: #fff;
  margin-top: 1.5rem;
`;
